import React from 'react'
import PropTypes from 'prop-types'
import { PhotoSwipeGallery } from 'react-photoswipe-component'
import '../../../../../node_modules/photoswipe/dist/photoswipe.css'
import '../../../../../node_modules/photoswipe/dist/default-skin/default-skin.css'
import '../../../../../node_modules/react-photoswipe-component/src/style.css'

const Photoswipe = props => {
  const { children, aImages } = props
  return (
    <PhotoSwipeGallery items={aImages} data-test="component-photoswipe">
      {children}
    </PhotoSwipeGallery>
  )
}

const imageVehicleShape = PropTypes.shape({
  src: PropTypes.string,
  w: PropTypes.number,
  h: PropTypes.number
})

Photoswipe.defaultProps = {}
Photoswipe.propTypes = {
  aImages: PropTypes.arrayOf(imageVehicleShape).isRequired,
  children: PropTypes.node.isRequired
}

export default Photoswipe
